// Canonical clients-table columns an admin may request a therapist to update,
// with display labels. Order here is the display order (diagnosis code first —
// it's the primary use case for insurance invoices).
export const PROFILE_UPDATE_FIELDS = [
  { key: 'diagnosis_code', label: 'Diagnosis Code' },
  { key: 'phone', label: 'Phone' },
  { key: 'email', label: 'Email' },
  { key: 'dob', label: 'Date of Birth' },
  { key: 'gender', label: 'Gender' },
  { key: 'address', label: 'Address' },
  { key: 'city', label: 'City' },
  { key: 'state', label: 'State' },
  { key: 'zip_code', label: 'Zip Code' },
  { key: 'billing_email', label: 'Billing Email' },
  { key: 'billing_address', label: 'Billing Address' },
  { key: 'emergency_contact_name', label: 'Emergency Contact Name' },
  { key: 'emergency_contact_phone', label: 'Emergency Contact Phone' },
  { key: 'guardian_name', label: 'Guardian Name' },
  { key: 'guardian_phone', label: 'Guardian Phone' },
  { key: 'reason_for_visit', label: 'Reason for Visit' },
  { key: 'medications', label: 'Medications' },
];

const LABELS = Object.fromEntries(PROFILE_UPDATE_FIELDS.map((f) => [f.key, f.label]));

export function fieldLabel(key) {
  return LABELS[key] || key;
}

export function fieldLabels(keys) {
  return (keys || []).map(fieldLabel).join(', ');
}
